/**
 * I VIDEOCORSI APERTI A UN CORSISTA — il piano SMART.
 *
 * Stessa forma di tutte le altre API di v1: fetch, `x-access-token`, `global.checkAuth`
 * sull'esito, promessa che risolve sul risultato buono e rifiuta con la risposta intera.
 *
 * ⚠️ L'IDENTIFICATIVO E' IL `clients.id` (`client.id_client` nella scheda), NON `client.id`
 * che e' l'utente. Le due tabelle hanno righe nelle stesse fasce di numeri: sbagliare non
 * da' errore, apre un videocorso a un'altra persona. E' la stessa trappola gia' pagata sulle
 * lezioni live il 1 settembre 2026.
 */

const intestazioni = () => ({
    'x-access-token': localStorage.getItem('hash'),
    'Content-Type': 'application/json'
});

/**
 * @param {string|string[]} attesi gli esiti che contano come riuscita.
 *
 * ⚠️ Piu' di uno serve davvero: aprire un corso risponde `..._CREATED` se la riga nasce e
 * `..._EXISTS` se c'era gia'. Per chi preme la spunta e' la stessa cosa — il corsista vede il
 * corso — e trattarne uno come errore farebbe comparire un messaggio rosso su un'operazione
 * riuscita.
 */
function chiama(url, opzioni, attesi) {
    const buoni = Array.isArray(attesi) ? attesi : [attesi];

    return new Promise(function (resolve, reject) {
        fetch(url, Object.assign({headers: intestazioni()}, opzioni || {}))
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                if (buoni.indexOf(responseJson.status) !== -1)
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
}

/** Tutti i videocorsi, con aperto si'/no. */
let list = function (idClient) {
    return chiama(global.route.clientCourses.replace('{id}', idClient),
        {method: 'GET'}, "COURSE_ENTITLEMENTS");
};

/** Apre un corso. Riuscita anche se era gia' aperto. */
let open = function (idClient, idCourse) {
    return chiama(global.route.clientCourses.replace('{id}', idClient),
        {method: 'PUT', body: JSON.stringify({id_course: idCourse})},
        ["COURSE_ENTITLEMENT_CREATED", "COURSE_ENTITLEMENT_EXISTS"]);
};

/** Chiude un corso. */
let close = function (idClient, idCourse) {
    return chiama(global.route.clientCourse.replace('{id}', idClient).replace('{idCourse}', idCourse),
        {method: 'DELETE'}, "COURSE_ENTITLEMENT_DELETED");
};

module.exports = {list, open, close};
